import React from "react";
import * as roomRTC from "../../services/roomRTC";

import "./Buttons.css";

const ButtonShare = ({ isScreenSharing, setIsScreenSharing, screenSharingStream, setScreenSharingStream }) => {

    const enableScreenSharing = async () => {
        let stream = null;

        try {
            stream = await navigator.mediaDevices.getDisplayMedia({ audio: true, video: true });
        } catch (error) {
            console.log("Error Screen Sharing");
        }

        if (stream) {
            roomRTC.toggleSharingScreen(isScreenSharing, stream);

            setIsScreenSharing(true);
            setScreenSharingStream(stream);
        }
    };

    const disableScreenSharing = () => {
        if (isScreenSharing) {
            roomRTC.toggleSharingScreen(isScreenSharing);
            screenSharingStream.getTracks().forEach(track => track.stop());

            setIsScreenSharing(false);
            setScreenSharingStream(null);
        }
    };

    return (
        <div className="btn_share_circle" title="Compartilhar apresentação" onClick={isScreenSharing ? disableScreenSharing : enableScreenSharing}>
            {isScreenSharing ?
                <span className="material-symbols-outlined btn_icon_style">screen_share</span> :
                <span className="material-symbols-outlined btn_icon_style">stop_screen_share</span>}
        </div>
    );
};

export default ButtonShare;